import React, { FC, ReactNode } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import { TCrmSchoolStatus } from '../../../../shared/common/api/endpoints/crmAnalyticsApi';
import { STATUS_META } from '../constants';
import styles from '../CrmAnalytics.module.scss';

// Заголовок с пояснением, как считается величина
export const HintTitle: FC<{ title: ReactNode; hint?: ReactNode }> = ({ title, hint }) => (
  <span style={{ whiteSpace: 'nowrap' }}>
    {title}
    {hint && (
      <Tooltip title={hint}>
        <QuestionCircleOutlined style={{ marginLeft: 6, color: '#bfbfbf' }} />
      </Tooltip>
    )}
  </span>
);

// Статус — цветная метка той же краски, что на графике, плюс подпись: цвет не несёт смысл в одиночку
export const StatusLabel: FC<{ status: TCrmSchoolStatus | null }> = ({ status }) => {
  if (!status) return <span>—</span>;

  const meta = STATUS_META[status];
  return (
    <Tooltip title={meta.hint}>
      <span className={styles.statusCell}>
        <span className={styles.statusDot} style={{ background: meta.color }} />
        {meta.label}
      </span>
    </Tooltip>
  );
};
